export default "__VITE_ASSET__4PGPkcHp__"